export const SEARCH_USERS_REQUEST = 'SEARCH_USERS_REQUEST'
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS'
export const SEARCH_USERS_FAILURE = 'SEARCH_USERS_FAILURE'
export const IS_USER_SEARCHING = 'IS_USER_SEARCHING'

export const RESET_USERS_FOUND = 'RESET_USERS_FOUND'
